import { createSlice } from '@reduxjs/toolkit';
import { orderBy } from 'lodash';

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';

//
import API from 'restApi';
import { dispatch } from '../store';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  allActorTypes: [],
  allProfiles: [],
  allFunctions: [],
  allActions: [],
  allActors: [],
  allExams: [],
  allLabos: [],
  allSetting: null,
  config: null

};

const slice = createSlice({
  name: 'all',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.actors = [];

    },
    // GET all types
    getAllActorTypesSuccess(state, action) {
      const { data } = action.payload;
      state.isLoading = false;
      const sortOrder = ['P', 'U', 'M', 'L'];
      data.sort((a, b) => sortOrder.indexOf(a.actortype) - sortOrder.indexOf(b.actortype));
      state.allActorTypes = data.map((item) => ({ code: item.actortype, label: item.actortype_label }));
    },

    // GET all Profiles
    getAllProfilesSuccess(state, action) {
      const { profiles } = action.payload;
      state.isLoading = false;
      state.allProfiles = profiles;
      state.error = null;

    },

    // GET all functions
    getAllFunctionsSuccess(state, action) {
      const { functions } = action.payload;
      state.isLoading = false;

      state.allFunctions = orderBy(functions, ['norder'], ['asc']);
    },
    // GET all actions
    getAllActionsSuccess(state, action) {
      const { actions } = action.payload;
      state.isLoading = false;
      state.allActions = actions;
    },
    // GET all actors
    getAllActorsSuccess(state, action) {
      const { actors } = action.payload;
      state.isLoading = false;
      state.allActors = actors?.map((item) => ({ code: item.actorcode, label: `${item.actorname || ''} (${item.actorcode})`, type: item.actortype }));
    },
    // GET all labos
    getAllLabosSuccess(state, action) {
      const { labos } = action.payload;
      state.isLoading = false;
      state.allLabos = labos?.map((item) => ({ code: item.actorcode, label: `${item.actorname || ''} (${item.actorcode})`, type: item.actortype }));
    },
    // GET setting
    getAllSettingSuccess(state, action) {
      const { setting } = action.payload;
      state.isLoading = false;
      state.allSetting = setting;
    },
    // GET exams
    getAllExamsSuccess(state, action) {
      const { exams } = action.payload;
      state.isLoading = false;
      state.allExams = exams;
    },
    // SET CONFIG
    setConfig(state, action) {
      state.config = action.payload;
    },

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  hasError,
  setConfig
} = slice.actions;

// ----------------------------------------------------------------------


export function getAllType() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.ALLACTORTYPE
      });
      const { data: { data } } = response;

      dispatch(slice.actions.getAllActorTypesSuccess({ data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllProfiles() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.ALLPROFILE
      });

      const { data: { data } } = response;
      const profiles = await data.map((item) => ({ code: item.profilecode?.trim(''), label: `${item.profilelabel?.trim('') || ''} (${item.profilecode?.trim('')})`, sortres: item.sortres?.trim('') }));
      dispatch(slice.actions.getAllProfilesSuccess({ profiles }));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllFunctions() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.ALLFONCTIONS
      });

      const { data: { data } } = response;
      dispatch(slice.actions.getAllFunctionsSuccess({ functions: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllActions() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.ALLACTIONS
      });

      const { data: { data } } = response;

      dispatch(slice.actions.getAllActionsSuccess({ actions: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllActors() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.ALLACTORS,
        navig: {
          nav_position: 0,
          nb_item_per_page: 20
        },
      });

      const { data: { actorsForPage } } = response;
      dispatch(slice.actions.getAllActorsSuccess({ actors: actorsForPage }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getAllLabos() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.ALLLABOS
      });

      const { data: { data } } = response;
      dispatch(slice.actions.getAllLabosSuccess({ labos: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllSetting(payload) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADPARAM
      });
      const { data: { params } } = response;
      dispatch(slice.actions.getAllSettingSuccess({ setting: { ...params, payload } }));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };

}

export function getAllExams() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADEXAMS
      });
      const { data: { examlist } } = response;
      dispatch(slice.actions.getAllExamsSuccess({ exams: examlist }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getUserActors({ type, navigPosition }) {

  try {
    const response = await axios.post(API.path, {
      action: ACTIONS.ALLACTORS,
      type,
      navig: {
        nav_position: navigPosition || 1,
        nb_item_per_page: 20
      },
    });

    const { data: { data } } = response;
    return data;

  } catch (error) {
    console.log(error);
    return null;
  }

}



